
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SupportTicketDto } from '@/services/api-clients';

@Component
export default class SupportChatHead extends Vue {
  @Prop({ type: Object, required: true }) ticket!: SupportTicketDto;

  @Prop({ type: Number, default: 0 }) unreadCount!: number;

  @Prop({ type: String, default: 'primary' }) color!: string;

  get initials(): string {
    const parts = (this.ticket.driverFullName ?? '').split(' ').filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
}
